import { Job } from '@/types';

// The export types supported in the export dropdown UI
export type ExportType =
  | 'seed'
  | 'asset'
  | 'risk'
  | 'technology'
  | 'agent'
  | 'person';

// Wider type accepted by the export API endpoint (not all are shown in the dropdown)
export type ApiExportType =
  | ExportType
  | 'webpage'
  | 'port'
  | 'adobject'
  | 'awsresource'
  | 'gcpresource'
  | 'azureresource'
  | 'cloudresource'
  | 'vulnerability'
  | 'person';

export function getEntityLabel(type: ApiExportType): string {
  switch (type) {
    case 'asset':
      return 'Assets';
    case 'seed':
      return 'Seeds';
    case 'risk':
      return 'Vulnerabilities';
    case 'technology':
      return 'Technologies';
    case 'agent':
      return 'Endpoints';
    case 'person':
      return 'People';
    default:
      return type.charAt(0).toUpperCase() + type.slice(1) + 's';
  }
}

function getJobConfig(job: Job): Record<string, string> | undefined {
  return job.config as Record<string, string> | undefined;
}

export function getOutputPath(job: Job): string {
  const config = getJobConfig(job);
  return config?.output ?? job.dns;
}

export function getJobType(job: Job): ExportType | null {
  const config = getJobConfig(job);
  const label = config?.label;

  // New capability-based exports store the label in config
  if (label) {
    switch (label) {
      case 'asset':
      case 'seed':
      case 'risk':
      case 'technology':
      case 'agent':
      case 'person':
        return label;
      default:
        return null;
    }
  }

  // Fall back to parsing the DNS/output path (legacy exports)
  const outputPath = getOutputPath(job);
  if (outputPath.startsWith('home/export-asset')) return 'asset';
  if (outputPath.startsWith('home/export-seed')) return 'seed';
  if (outputPath.startsWith('home/export-risk')) return 'risk';
  if (outputPath.startsWith('home/export-technology')) return 'technology';
  if (outputPath.startsWith('home/export-agent')) return 'agent';
  if (
    outputPath.startsWith('home/guard-export-person') ||
    outputPath.startsWith('home/export-person')
  )
    return 'person';
  return null;
}
